/* Regional Formspree bridge. PDF emailing is a separate service. */
(() => {
  'use strict';
  // Block editor submissions before hostname routing or SDK registration.
  function blockEditorForms() {
    if (window.Shopify?.designMode !== true) return;
    document.querySelectorAll('form[data-fp-formspree]').forEach(form => {
      form.querySelectorAll('[type="submit"]').forEach(button => { button.disabled = true; });
      form.addEventListener('submit', event => { event.preventDefault(); event.stopImmediatePropagation(); }, true);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', blockEditorForms, { once: true });
  else blockEditorForms();
  if (window.FocusPodFormspree) return;
  const routes = {
    'focuspod.com.au': ['xaqzydew', 'AU', 'AUD'],
    'focuspodgroup.com': ['xdeknogj', 'US', 'USD'],
    'focuspod.sg': ['mdekpqnq', 'SG', 'SGD'],
    'id.focuspodgroup.com': ['xrpeqjda', 'ID', 'IDR'],
    'ie.focuspodgroup.com': ['xnpjdwro', 'IE', 'EUR'],
    'de.focuspodgroup.com': ['mjygwlzj', 'DE', 'EUR'],
    'be.focuspodgroup.com': ['xaeqovkk', 'BE', 'EUR'],
    'nl.focuspodgroup.com': ['mqpeqnjo', 'NL', 'EUR'],
    'my.focuspodgroup.com': ['mljgbzvy', 'MY', 'MYR'],
    'ch.focuspodgroup.com': ['myekwovr', 'CH', 'CHF'],
    'fi.focuspodgroup.com': ['mzedroqp', 'FI', 'EUR'],
    'se.focuspodgroup.com': ['meaegnwq', 'SE', 'SEK'],
    'at.focuspodgroup.com': ['xoejdrzv', 'AT', 'EUR'],
    'dk.focuspodgroup.com': ['xqpeqnoo', 'DK', 'DKK'],
    'jp.focuspodgroup.com': ['mkjoryar', 'JP', 'JPY'],
    'ke.focuspodgroup.com': ['mppqdbep', 'KE', 'KES'],
    'pk.focuspodgroup.com': ['mgaokdbo', 'PK', 'PKR'],
    'ng.focuspodgroup.com': ['xoejwewj', 'NG', 'NGN'],

    'eg.focuspodgroup.com': ['mvkzayok', 'EG', 'EGP'],
    'mx.focuspodgroup.com': ['mgaokqee', 'MX', 'MXN'],
    'hk.focuspodgroup.com': ['xdeagbjb', 'HK', 'HKD'],
    'vn.focuspodgroup.com': ['mkjobjbb', 'VN', 'VND'],
    'th.focuspodgroup.com': ['xqpeqjkn', 'TH', 'THB'],
    'br.focuspodgroup.com': ['mnpjdrqb', 'BR', 'BRL'],
    'tr.focuspodgroup.com': ['mrpeqdgk', 'TR', 'TRY'],
    'cz.focuspodgroup.com': ['xwlvoydq', 'CZ', 'CZK'],
    'hu.focuspodgroup.com': ['mrpeqjva', 'HU', 'HUF'],
    'kr.focuspodgroup.com': ['mwlvoyjq', 'KR', 'KRW'],
    'ar.focuspodgroup.com': ['mvkzalnr', 'AR', 'ARS'],
    'no.focuspodgroup.com': ['xljgbzky', 'NO', 'NOK'],
    'pl.focuspodgroup.com': ['xzedrolp', 'PL', 'PLN'],
    'fr.focuspodgroup.com': ['xeaegnbq', 'FR', 'EUR'],
    'it.focuspodgroup.com': ['moejdrov', 'IT', 'EUR'],
    'sa.focuspodgroup.com': ['xrpeqjwa', 'SA', 'SAR'],
    'ph.focuspodgroup.com': ['xgaokdjo', 'PH', 'PHP'],
    'pt.focuspodgroup.com': ['mbgdowvz', 'PT', 'EUR'],
    'ro.focuspodgroup.com': ['mzedronp', 'RO', 'RON'],
    'gr.focuspodgroup.com': ['xnpjdwko', 'GR', 'EUR'],
    'es.focuspodgroup.com': ['xvkzaljr', 'ES', 'EUR'],
    'tw.focuspodgroup.com': ['mjygwlqj', 'TW', 'TWD'],
    'il.focuspodgroup.com': ['xdeagbrb', 'IL', 'ILS'],
    'focuspods.co.uk': ['mqpazkqv', 'GB', 'GBP'],
    'focuspod.co.nz': ['mwlekaed', 'NZ', 'NZD'],
    'focuspodae.com': ['xyezgypg', 'AE', 'AED'],
    'focuspod.co.za': ['xeaojqzo', 'ZA', 'ZAR']
  };
  const route = routes[location.hostname.toLowerCase().replace(/^www\./, '')];
  if (!route) return;
  window.FocusPodFormspree = Object.freeze({ version: '1.0.1' });
  window.formspree = window.formspree || function () {
    (window.formspree.q = window.formspree.q || []).push(arguments);
  };

  function init(form) {
    if (window.Shopify?.designMode === true || form.dataset.fpPrivateNoSend === 'true') {
      form.querySelectorAll('[type="submit"]').forEach(button => { button.disabled = true; });
      form.addEventListener('submit', event => { event.preventDefault(); event.stopImmediatePropagation(); }, true);
      return;
    }
    if (form.dataset.fpFormspreeReady) return;
    form.dataset.fpFormspreeReady = 'true';
    const copy = form.querySelector('[data-fp-enquiry-copy]').dataset;
    const success = form.querySelector('[data-fp-enquiry-success]');
    const error = form.querySelector('[data-fp-enquiry-error]');
    const message = error.querySelector('[data-fp-error-message]');
    const status = form.querySelector('[data-market-form-status]');
    const buttons = [...form.querySelectorAll('[type="submit"]')];
    let submitted = false, uncertain = false, attempt = null;

    function showError(text) {
      message.textContent = text;
      error.hidden = false;
      if (status) status.textContent = '';
      error.focus();
    }
    function lock(value) {
      form.setAttribute('aria-busy', String(value));
      buttons.forEach(button => { button.disabled = value || submitted || uncertain; });
    }
    function verifiedRoute() {
      return form.dataset.fpFormspree === route[0] &&
        form.getAttribute('action') === 'https://formspree.io/f/' + route[0];
    }
    // This capture guard also protects the native POST fallback if the CDN fails.
    form.addEventListener('submit', event => {
      if (!verifiedRoute() || submitted || uncertain) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!submitted) showError(uncertain ? copy.uncertain : copy.unavailable);
      }
    }, true);
    if (!verifiedRoute()) {
      buttons.forEach(button => { button.disabled = true; });
      showError(copy.unavailable);
      return;
    }
    const journeySignal=(event,parameters={})=>{try{document.dispatchEvent(new CustomEvent('focuspod:measurement_observed',{detail:{event,parameters,delivery:'journey-signal'}}));}catch{}};
    window.formspree('initForm', {
      formElement: '#' + form.id,
      formId: route[0],
      disable: () => lock(true),
      enable: () => lock(false),
      onSubmit: () => {
        error.hidden = true;
        if (status) status.textContent = copy.sending;
        const tracking = [...form.querySelectorAll('[data-fp-attribution]')]
          .find(input => input.name === 'contact[Tracking lead ID]');
        const id = tracking?.value || window.crypto?.randomUUID?.();
        const summary = form.querySelector('[name="contact[Configuration summary]"]');
        const requested = form.querySelector('#market-currency')?.value || route[2];
        attempt = {
          event_id: id,
          lead_type: summary?.value.trim() ? 'configurator_quote' : 'contact_form',
          requested_quote_currency: ['AUD', 'USD', 'GBP', 'NZD', 'AED', 'ZAR', 'SGD', 'IDR', 'EUR', 'MYR', 'CHF', 'SEK', 'DKK', 'NOK', 'PLN', 'SAR', 'PHP', 'RON', 'TWD', 'HKD', 'ILS', 'CZK', 'HUF', 'KRW', 'ARS', 'VND', 'THB', 'BRL', 'TRY', 'EGP', 'MXN', 'JPY', 'KES', 'PKR', 'NGN'].includes(requested) ? requested : '',
          placement: 'contact_page'
        };
        journeySignal('quote_submit_attempt',{event_id:id,placement:'contact_page'});
        // Native tracking skips AJAX's prevented submit. Its consent-aware API
        // handles these callbacks without sending names, email or form contents.
        if (id) window.FocusPodMeasurement?.track(
          'quote_submit_attempt', { event_id: id, placement: 'contact_page' }
        );
      },
      onSuccess: () => {
        if (submitted) return;
        submitted = true;
        error.hidden = true;
        if (attempt?.event_id) {
          window.FocusPodMeasurement?.track('generate_lead', {
            event_id: attempt.event_id,
            lead_type: attempt.lead_type,
            requested_quote_currency: attempt.requested_quote_currency,
            placement: attempt.placement,
            confirmed: true
          });
        }
        if(attempt?.event_id)journeySignal('generate_lead',{event_id:attempt.event_id,lead_type:attempt.lead_type,confirmed:true});
        // Only confirmed success can trigger the legacy attachment cleanup.
        success.setAttribute('data-contact-success', '');
        if (form.id === 'FocusPodUSContact') success.classList.add('fp-us-form-success');
        success.hidden = false;
        form.dispatchEvent(new CustomEvent('fp:enquiry-success', { bubbles: true }));
        form.reset();
        form.querySelectorAll('[data-market-attachment],#fp-us-enquiry-config').forEach(node => { node.hidden = true; });
        if (status) status.textContent = '';
        lock(false);
        success.focus();
      },
      onError: () => {journeySignal('journey_error',{error_category:'quote_failed',event_id:attempt?.event_id});showError(copy.error);},
      onFailure: () => {
        // A lost response does not prove the server rejected the enquiry.
        // Avoid sending it twice; the same regional inbox remains available.
        journeySignal('journey_error',{error_category:'quote_uncertain',event_id:attempt?.event_id});
        uncertain = true;
        lock(false);
        showError(copy.uncertain);
      }
    });
  }
  function boot() { document.querySelectorAll('form[data-fp-formspree]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
